import React, { FunctionComponent, useEffect } from 'react';
import BannerImage from 'src/components/BannerImage/BannerImage';
import './PublicPage.scss';
import { PublicPageProps } from 'src/model/general/public-pages';
import { animated, useTransition } from '@react-spring/web';
import useNotification from 'src/hooks/useNotification';
import { FlightSnackbar } from '@flybits/design-system';
import { useHistory } from 'react-router-dom';
import { Location } from 'history';
import { PUBLIC_PAGE_TITLES } from 'src/constants/titles';

const PublicPage: FunctionComponent<PublicPageProps> = (props: PublicPageProps) => {
  const { children, style, showBanner, setBannerVisibility } = props;
  const { message, removeNotification } = useNotification();
  const history = useHistory();
  useEffect(() => {
    setBannerVisibility(true);
    // Set dynamic document title
    document.title =
      (PUBLIC_PAGE_TITLES[history.location.pathname] || PUBLIC_PAGE_TITLES['/default']) + ' - Control Tower';
    history.listen((location: Location) => {
      // Set dynamic document title
      document.title = (PUBLIC_PAGE_TITLES[location.pathname] || PUBLIC_PAGE_TITLES['/default']) + ' - Control Tower';
      // check for sw updates on page change
      navigator.serviceWorker.getRegistrations().then((regs) => regs.forEach((reg) => reg.update()));
    });
  }, []);

  const MAIN_CLASS = 'public_page';

  const animationPropsLeft = {
    from: { width: '0vw', height: '100%' },
    enter: { width: '50vw' },
    leave: { width: '0vw' },
    config: { duration: 300 },
  };
  const animationPropsRight = {
    from: {
      width: '100%',
      height: '100%',
      overflowY: 'auto',
      overflowX: 'hidden',
      opacity: 0,
    },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { duration: 300 },
  };
  const AnimateBanner = animated(BannerImage);

  const bannerTransitions = useTransition(showBanner, {
    from: animationPropsLeft.from,
    enter: animationPropsLeft.enter,
    leave: animationPropsLeft.leave,
    config: animationPropsLeft.config,
  });
  const childrenTransitions = useTransition(showBanner, {
    from: animationPropsRight.from,
    enter: animationPropsRight.enter,
    leave: animationPropsRight.leave,
    config: animationPropsRight.config,
  });
  return (
    <>
      <FlightSnackbar
        isVisible={!!message}
        isFloating
        className={`show__info`}
        animation
        isAutoDismiss={true}
        dismissAfter={5000}
        type={message.startsWith('!!!') ? 'error' : message.startsWith('~~~') ? 'warning' : 'default'}
        icon={message.startsWith('!!!') ? 'error' : message.startsWith('~~~') ? 'warning' : ''}
        actionName=""
        content={message.replace(/[\!\~]{3}/g, '')}
        handleClose={() => {
          removeNotification();
        }}
      />
      <div className={MAIN_CLASS} role="main" style={style}>
        {bannerTransitions((style, item) => (item ? <AnimateBanner style={style} /> : null))}
        {childrenTransitions((style, item) => (item ? <animated.div style={style}>{children}</animated.div> : null))}
      </div>
    </>
  );
};
export default PublicPage;
